import { Outlet, Navigate, useLocation } from "react-router";
import { Navbar } from "../Navigation/Navbar";
import { getAuthToken } from "../../helpers";

export const Layout = () => {
  const router = useLocation();
  if (!getAuthToken() && router.pathname !== "/login") return <Navigate to="/login" />;

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <main className="px-4 md:px-11 py-8 max-w-[2000px] mx-auto">
        <Outlet />
      </main>
    </div>
  );
};
